import MentorRequestContainer from '../mentor-request-container';
import { useMentorRequestContext } from '../mentor-request-context';

const PendingRequestMentorView = () => {
  const { request } = useMentorRequestContext();
  return (
    <>
      <MentorRequestContainer.Header />
      <MentorRequestContainer.Request request={request} />
      <MentorRequestContainer.ApprovalActions />
    </>
  );
};

export default PendingRequestMentorView;
